import type { RotationLimitsAxisMode } from '../../lib/skeleton/rotationLimits';

export type AxisMode = RotationLimitsAxisMode;

export const AXES = ['x', 'y', 'z'] as const;
export const AXIS_MODE_OPTIONS: Array<{
  value: AxisMode;
  label: string;
  description?: string;
}> = [
  {
    value: 'unlimited',
    label: 'Free',
    description: 'No axis limits',
  },
  {
    value: 'limited',
    label: 'Limited',
    description: 'Set minimum and maximum angle bounds',
  },
  {
    value: 'locked',
    label: 'Locked',
    description: 'Axis cannot rotate',
  },
];

export const INSPECTOR_CONTROL_CLASS =
  'border-gray-30/80 dark:border-gray-60/80 bg-white/65 hover:bg-white/80 dark:bg-gray-90/65 dark:hover:bg-gray-90/80 text-primary h-5 rounded-lg border transition-colors duration-150 focus-visible:bg-white dark:focus-visible:bg-gray-90 focus-visible:border-blue-50 focus-visible:outline-none';
export const INSPECTOR_SELECT_WRAPPER_CLASS = 'relative w-[140px] shrink-0';
export const INSPECTOR_SELECT_CLASS = 'h-5 w-full px-2 pr-2';
export const INSPECTOR_NUMBER_INPUT_CLASS = `${INSPECTOR_CONTROL_CLASS} w-14 px-1`;
export const INSPECTOR_AXIS_LABEL_CLASS =
  'text-gray-90 dark:text-white inline-flex h-5 w-3 items-center justify-center';
export const INSPECTOR_TRANSLATE_DRAG_DELTA_PER_PIXEL = 0.02;
export const INSPECTOR_ROTATE_DRAG_DELTA_PER_PIXEL = 0.2;
export const INSPECTOR_DRAG_SLOW_MODIFIER = 0.2;
export const INSPECTOR_DRAG_FAST_MODIFIER = 5;
export const INSPECTOR_CONTROL_TEXT_STYLE = {
  fontSize: '12px',
  lineHeight: '16px',
  fontWeight: 500,
} as const;

export const ROTATION_LIMITS_TOOLTIP_TEXT = 'Bone Rotation Limits.';
export const PREFERRED_ANGLES_TOOLTIP_TEXT =
  'Preferred angles bias the bone toward a bend direction';
